
import * as React from "react"
import email from '../home/email.png'
const EmailIconFooter = (props) => (
  <div className="">
    <img src={email} alt="" />
  </div>
)

export default EmailIconFooter
